import type { WatchPart } from '../api/client'
import {
  isConsolidatedPart,
  partVariants,
  selectedVariantId,
} from '../lib/partVariants'

type CaseVariantPickerProps = {
  part: WatchPart
  onVariantChange?: (variantId: string) => void
  compact?: boolean
}

export function CaseVariantPicker({ part, onVariantChange, compact = false }: CaseVariantPickerProps) {
  if (!isConsolidatedPart(part)) {
    return null
  }

  const variants = partVariants(part).filter((variant) => variant.available)
  if (variants.length <= 1) {
    return null
  }

  const currentVariantId = selectedVariantId(part)

  return (
    <label className={`case-variant-picker${compact ? ' case-variant-picker--compact' : ''}`}>
      <span className="case-variant-picker-label">Case options</span>
      <select
        className="case-variant-picker-select"
        value={currentVariantId ?? ''}
        onChange={(event) => onVariantChange?.(event.target.value)}
      >
        {variants.map((variant) => (
          <option key={variant.variant_id} value={variant.variant_id}>
            {variant.title} — ${variant.price.toFixed(0)}
          </option>
        ))}
      </select>
    </label>
  )
}
